/* eslint-disable camelcase */

import { Button } from '@chakra-ui/react';
import { useCallback } from 'react';
import { useUpdateOrderStatusMutation } from '../../utils/__generated__/graphql';

export enum OrderState {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  COOKING = 'COOKING',
  ASSIGNED = 'ASSIGNED',
  SHIPPING = 'SHIPPING',
  DELIVERED = 'DELIVERED',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
}

const ORDER_FLOW: OrderState[] = [
  OrderState.ACCEPTED,
  OrderState.COOKING,
  OrderState.ASSIGNED,
  OrderState.SHIPPING,
  OrderState.DELIVERED,
  OrderState.COMPLETED,
];

interface OrderStateSelectProps {
  orderId: string;
  orderState: OrderState;
  refetch?: () => void;
}

export const OrderStateSelect: React.FC<OrderStateSelectProps> = ({ orderId, orderState, refetch }) => {
  const [updateOrderStatus] = useUpdateOrderStatusMutation({
    onCompleted: refetch,
  });

  const getNextState = useCallback((currentState: OrderState): OrderState | null => {
    const currentIndex = ORDER_FLOW.indexOf(currentState);
    if (currentIndex < ORDER_FLOW.length - 1) {
      return ORDER_FLOW[currentIndex + 1];
    }
    return null;
  }, []);

  const handleStateChange = useCallback(async () => {
    const nextState = getNextState(orderState);
    if (nextState) {
      await updateOrderStatus({
        variables: {
          pk_columns: { id: orderId },
          _set: { status: nextState },
        },
      });
      return nextState;
    }
    return null;
  }, [orderId, orderState, updateOrderStatus, getNextState]);

  const nextState = getNextState(orderState);

  if (!nextState) {
    return null; // No button if there's no next state
  }

  const buttonText = `START ${nextState}`;

  return (
    <Button
      onClick={handleStateChange}
      colorScheme="teal"
      isDisabled={orderState === OrderState.COMPLETED || orderState === OrderState.CANCELED}
    >
      {buttonText}
    </Button>
  );
};

// // OrderStateSelect.tsx
// import { Select } from '@chakra-ui/react';
// import { useState, useCallback } from 'react';
// import { useUpdateOrderStatusMutation } from '../../utils/__generated__/graphql';

// export enum OrderState {
//   PENDING = 'PENDING',
//   ACCEPTED = 'ACCEPTED',
//   COOKING = 'COOKING',
//   DELIVERED = 'DELIVERED',
//   SHIPPING = 'SHIPPING',
//   COMPLETED = 'COMPLETED',
//   CANCELED = 'CANCELED',
// }

// interface OrderStateSelectProps {
//   orderId: string;
//   orderState: string;
//   refetch?: () => void;
// }

// export const OrderStateSelect: React.FC<OrderStateSelectProps> = ({ orderId, orderState, refetch }) => {
//   const [selectedState, setSelectedState] = useState<string>(orderState);

//   const [updateOrderStatus] = useUpdateOrderStatusMutation({
//     onCompleted: refetch,
//   });

//   const handleChange = useCallback(
//     async (event: React.ChangeEvent<HTMLSelectElement>) => {
//       const newState = event.target.value as OrderState;
//       setSelectedState(newState);
//       await updateOrderStatus({
//         variables: {
//           pk_columns: { id: orderId },
//           _set: { status: newState },
//         },
//       });
//     },
//     [orderId, updateOrderStatus]
//   );

//   const isDisabled = useCallback(
//     (state: OrderState) => {
//       const currentStateIndex = Object.values(OrderState).indexOf(selectedState as OrderState);
//       const stateIndex = Object.values(OrderState).indexOf(state);
//       return (
//         stateIndex <= currentStateIndex ||
//         selectedState === OrderState.CANCELED ||
//         selectedState === OrderState.COMPLETED
//       );
//     },
//     [selectedState]
//   );

//   return (
//     <Select value={selectedState} onChange={handleChange}>
//       {Object.values(OrderState).map((state) => (
//         <option key={state} value={state} disabled={isDisabled(state)}>
//           {state}
//         </option>
//       ))}
//     </Select>
//   );
// };

// /* eslint-disable camelcase */
// import { Select } from '@chakra-ui/react';
// import { useState } from 'react';
// import { useUpdateOrderStatusMutation } from '../../utils/__generated__/graphql';

// export enum OrderState {
//   PENDING = 'PENDING',
//   ACCEPTED = 'ACCEPTED',
//   COOKING = 'COOKING',
//   DELIVERED = 'DELIVERED',
//   SHIPPING = 'SHIPPING',
//   COMPLETED = 'COMPLETED',
//   CANCELED = 'CANCELED',
// }

// interface OrderStateSelectProps {
//   orderId: string;
//   orderState: string;
//   refetch?: () => void | undefined;
// }

// export const OrderStateSelect = (props: OrderStateSelectProps) => {
//   const { orderId, orderState, refetch } = props;

//   const [selectedState, setSelectedState] = useState<string>(orderState);

//   const [updateOrderStatus] = useUpdateOrderStatusMutation({
//     onCompleted: refetch,
//   });

//   const handleChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
//     setSelectedState(event.target.value);
//     await updateOrderStatus({
//       variables: {
//         pk_columns: { id: orderId },
//         _set: { status: event.target.value },
//       },
//     });
//   };

//   return (
//     <Select value={selectedState} onChange={handleChange}>
//       <option
//         value={OrderState.ACCEPTED}
//         disabled={
//           selectedState === OrderState.ACCEPTED ||
//           selectedState === OrderState.SHIPPING ||
//           selectedState === OrderState.COOKING ||
//           selectedState === OrderState.DELIVERED ||
//           selectedState === OrderState.CANCELED ||
//           selectedState === OrderState.COMPLETED
//         }
//       >
//         {OrderState.ACCEPTED}
//       </option>
//       <option
//         value={OrderState.COOKING}
//         disabled={
//           selectedState === OrderState.COOKING ||
//           selectedState === OrderState.SHIPPING ||
//           selectedState === OrderState.DELIVERED ||
//           selectedState === OrderState.CANCELED ||
//           selectedState === OrderState.COMPLETED
//         }
//       >
//         {OrderState.COOKING}
//       </option>
//       <option
//         value={OrderState.SHIPPING}
//         disabled={
//           selectedState === OrderState.SHIPPING ||
//           selectedState === OrderState.DELIVERED ||
//           selectedState === OrderState.CANCELED ||
//           selectedState === OrderState.COMPLETED
//         }
//       >
//         {OrderState.SHIPPING}
//       </option>
//       <option
//         value={OrderState.DELIVERED}
//         disabled={selectedState === OrderState.CANCELED || selectedState === OrderState.COMPLETED}
//       >
//         {OrderState.DELIVERED}
//       </option>
//       <option value={OrderState.CANCELED} disabled={selectedState === OrderState.COMPLETED}>
//         {OrderState.CANCELED}
//       </option>
//     </Select>
//   );
// };
